<template>
  <div class="ucindex">
    <div class="uc-banner" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <canvas id="canvas" style="width:500px;height:200px;z-index:1;"></canvas>
      <div class="userinfo" v-if="projectName != 'xurigo'">
        <router-link to="/usercenter/person">
          <div class="mu-paper demo-paper mu-paper-circle mu-paper-round mu-paper-2 headpic"><img :src="headPic"></div>
        </router-link>
        <router-link class="login-btn" :to="loginUrl">
          <p>
            <i class="fa fa-diamonds icon"></i>
            <span>{{showName}}</span>
            <i class="fa fa-angle-right"></i>
          </p>
        </router-link>
        <router-link to="/UserCenter/option"><mu-icon-button class="btn-option" primary><i class="fa fa-option2"></i></mu-icon-button></router-link>
        <router-link to="/UserCenter/messageTypeList" class="btn-msg">        
          <mu-badge :content="msgCount" circle secondary badgeClass="msg-badge" v-if="msgCount<=99">
            <i class="fa fa-commenting-o"></i>
          </mu-badge>
          <mu-badge content="99+" circle secondary badgeClass="msg-badge-more" v-if="msgCount>99">
            <i class="fa fa-commenting-o"></i>
          </mu-badge>
        </router-link>
      </div>
      <div class="userinfo" v-if="projectName == 'xurigo'">
          <router-link to="/usercenter/person">
            <div class="mu-paper demo-paper mu-paper-circle mu-paper-round mu-paper-2 headpic"><img :src="headPic"></div>
          </router-link>
          <p class="memberLv" v-if="loginStatus==1">
            <span class="nickName" v-if="nickName">{{nickName}}</span>
            <a v-else href="/#/usercenter/person"><span class="nickName" >请完善资料</span></a>
            <!--<span class="level"><i class="fa fa-diamonds icon"></i>初级会员</span>-->
            <span class="level"><i class="fa fa-diamonds icon"></i>{{indexInfo.UserBsName}}</span>
          </p>
          <router-link class="login-btn" v-if="loginStatus==0" :to="loginUrl">
            <p>
              <i class="fa fa-diamonds icon"></i>
              <span>{{showName}}</span>
              <i class="fa fa-angle-right"></i>
            </p>
          </router-link>
          <p class="inviteCode" v-if="loginStatus==1 && UserBs>0">
            <span></span>邀请码：</span>
            <span>{{showName}}</span>
            <span class="copyBtn" @click="copyCode">复制</span>
          </p>
          <router-link class="goInfo" v-if="loginStatus==1" :to="loginUrl">
              <i class="fa fa-angle-right"></i>
          </router-link>

          <router-link to="/UserCenter/option"><mu-icon-button class="btn-option" primary><i class="fa fa-option2"></i></mu-icon-button></router-link>
          <router-link to="/UserCenter/messageTypeList" class="btn-msg">        
            <mu-badge :content="msgCount" circle secondary badgeClass="msg-badge" v-if="msgCount<=99">
              <i class="fa fa-commenting-o"></i>
            </mu-badge>
            <mu-badge content="99+" circle secondary badgeClass="msg-badge-more" v-if="msgCount>99">
              <i class="fa fa-commenting-o"></i>
            </mu-badge>
          </router-link>
      </div>
      <div class="top-nav-list">
        <template>
          <router-link :to="salesmanUrl">
            <div class="top-nav-item">
              <mu-icon value=":fa fa-circle2"></mu-icon>
              <p class="text">{{salesmanUrlText}}</p>
            </div>
          </router-link>
        </template>
        <router-link to="/usercenter/coinWithdraw">
          <div class="top-nav-item">
            <mu-icon value=":fa fa-circle2"></mu-icon>
            <p class="text">金币提现</p>
          </div>
        </router-link>
        <router-link to="/usercenter/safe">
          <div class="top-nav-item">
            <mu-icon value=":fa fa-circle2"></mu-icon>
            <p class="text">密码管理</p>
          </div>
        </router-link>
      </div>
    </div>    
    <div class="top-main"  @touchstart="touchStart($event)" @touchmove="touchMove($event)"  @touchend="touchEnd($event)">
      <div class="index-title" style="display: block;">
        <router-link to="/usercenter/allorderlist">
          <p class="text">全部订单</p>
          <mu-icon value=":fa fa-angle-right" class="icon"></mu-icon>
          <p class="remark">查看全部订单</p>
        </router-link>
      </div>
      <div class="top-main-content">
      <div class="top-main-item">
        <router-link to="/usercenter/allorderlist?searchType=1">
          <mu-badge :content="orderCount.WaitPayCount.toString()" circle secondary>
            <i class="fa fa-waitpay"></i>
          </mu-badge>
          <p class="text">待付款</p>
        </router-link>
      </div>        
      <div class="top-main-item">
        <router-link to="/usercenter/allorderlist?searchType=2">
          <mu-badge :content="orderCount.WaitDeliveryCount.toString()" circle secondary>
            <i class="fa fa-delivery"></i>
          </mu-badge>
          <p class="text">待发货</p>
        </router-link>
      </div>
      <div class="top-main-item">
        <router-link to="/usercenter/allorderlist?searchType=3">        
          <mu-badge :content="orderCount.WaitReceiveCount.toString()" circle secondary>
            <i class="fa fa-receive"></i>
          </mu-badge>
          <p class="text">待收货</p>
        </router-link>      
        </div>
        
          <div class="top-main-item">
            <router-link to="/usercenter/allorderlist?searchType=4">
            <mu-badge :content="orderCount.WaitEvalueCount.toString()" circle secondary>
              <i class="fa fa-evaluate"></i>
            </mu-badge>
            <p class="text">待评价</p>
        </router-link>
          </div>
        <div class="top-main-item">
          <router-link to="/usercenter/sellservicelist">
            <mu-badge :content="orderCount.SellServiceCount.toString()" circle secondary>
              <i class="fa fa-sellservice"></i>
            </mu-badge>
            <p class="text">退/换货</p>
          </router-link>
        </div>
      </div>
    </div>
    <div class="myasset">      
      <div class="index-title">
        <img src="static/1221.png" alt="">
          <p class="text">我的资产</p>
        <img src="static/1221.png" alt="">
      </div>
      <div class="asset-list">
        <router-link to="/usercenter/coin" class="asset-item-a">
          <div class="item coin">
            <p class="num">{{memberFinance.Coin.toFixed(2).toString()}}</p>
            <p class="name">金币</p>
          </div>
        </router-link>

        <!-- <router-link to="/usercenter/integral" class="asset-item-a">
          <div class="item coin">
            <p class="num">{{memberFinance.Integral.toString()}}</p>
            <p class="name">积分</p>
          </div>
        </router-link> -->
        <router-link to="/usercenter/baw" class="asset-item-a">
          <div class="item baw">
            <p class="num">{{bawCount.toFixed(0)}}</p>
            <p class="name">BAW</p>
          </div>
        </router-link>
		<!--
        <router-link to="/usercenter/sun" class="asset-item-a">
          <div class="item coin">
            <p class="num">{{memberFinance.Sun.toFixed(4).toString()}}</p>
            <p class="name">SUN</p>
          </div>
        </router-link>
		-->
		
		<router-link v-if="isActivity" to="/usercenter/jft" class="asset-item-a">
          <div class="item coin">
            <p class="num">{{jftCoin.toFixed(4).toString()}}</p>
            <p class="name">JKT</p>
          </div>
        </router-link>
		<router-link v-if="!isActivity" to="/usercenter/JFTActive" class="asset-item-a">
          <div class="item coin">
            <p class="num">未激活</p>
            <p class="name">JKT</p>
          </div>
        </router-link>
		
      </div>  
    </div>
    <div class="coupon" v-if="myCouponList && myCouponList.length>0 && !closeCoupon">      
      <div class="index-title">
        <p class="text">卡券红包</p>
      </div>
      <ul class="coupon_sec_body">
        <li  v-for="couponRow in myCouponList" :key="couponRow.CouponId" class="coupon_default_inner">       
            <div :class="couponRow.CouponType=='0'? 'couponRink':'couponYellow'" class="couponLeft"
             :style="{backgroundImage: 'url(' + (couponRow.CouponType=='0'? bg1:bg2) + ')'}">
                <div class="coupon_discount" >
                    <p class="cost">￥</p>
                    <p class="money">{{couponRow.Money}}</p>
                </div>
            </div>
            <div class="couponRight" :class="couponRow.CouponType=='0'? 'couponRink':'couponYellow'">              
              <div class="coupon_content" :style="{width:couponWidth+'px'}">
                <p class="coupon_title">
                  <span class="coupon_type">{{couponRow.CouponTypeName}}</span> {{couponRow.Name}}
                </p>
                <p class="limit">
                    使用门槛：满{{couponRow.FullMoney}}元可用
                </p>
                <p class="date">
                  使用时间：{{couponRow.StartTime}} ~ {{couponRow.EndTime}}
                </p>                
              </div>
            </div>
        </li>
      </ul>
      <div class="coupon_btn">
          <mu-flat-button label="平台优惠券" icon=":fa fa-shopauth" class="demo-flat-button" to='/retail/coupon/couponuse?type=0' />
          <mu-flat-button label="店铺优惠券" icon=":fa fa-withdraw"  class="demo-flat-button" to='/retail/coupon/couponuse?type=1'/>
          <mu-flat-button label="红包" icon=":fa fa-imgzoom" class="demo-flat-button"/>
      </div>
    </div>
    <div class="myactived">      
      <div class="index-title">
        <img src="static/1221.png" alt="">
        <p class="text">我的活动</p>
        <img src="static/1221.png" alt="">
      </div>
      <div class="actived-list">
        <!-- <div class="actived-item">
          <router-link to="/usercenter/sign">
            <i class="fa fa-pencil2 qd"></i>
            <p class="text" style="padding-top:9px;">我的签到</p>
          </router-link>
        </div> -->
        <div class="actived-item" v-if="salesmanInfo.UserBs>0">
          <router-link to="/salesman/mytuijian">
            <!--<div v-if="salesmanInfo.MyTjMemberNum>0"><div class="mu-avatar-inner">{{salesmanInfo.MyTjMemberNum}}</div></div>-->
            <!--<i class="fa fa-people3 fav"></i>-->
            <img style="width: 35px;" src="/static/index/tuijian.png">
            <p class="text" style="padding-top:9px;">我的推荐</p>
          </router-link>
        </div>
        <div class="actived-item" v-if="salesmanInfo.UserBs==6 ||salesmanInfo.UserBs==7||salesmanInfo.UserBs==8">
          <router-link to="/salesman/mydaili">
            <!--<div v-if="salesmanInfo.MyProxyNum>0"><div class="mu-avatar-inner">{{salesmanInfo.MyProxyNum}}</div></div>-->
            <!--<i class="fa fa-money4 ts"></i>-->
            <img style="width: 35px;" src="/static/index/daili.png">
            <p class="text" style="padding-top:9px;">我的代理</p>
          </router-link>
        </div>
        <div class="actived-item" v-if="salesmanInfo.UserBs>0">
          <router-link to="/salesman/myzhaoshang">
            <!--<div v-if="salesmanInfo.MyCanvassNum>0"><div class="mu-avatar-inner">{{salesmanInfo.MyCanvassNum}}</div></div>-->
            <!--<i class="fa fa-brand qd"></i>-->
            <img style="width: 35px;" src="/static/index/zhaoshang.png">
            <p class="text" style="padding-top:9px;">我的招商</p>
          </router-link>
        </div>
        <div class="actived-item" v-if="salesmanInfo.UserBs>0">
          <router-link to="/salesman/myCard">
            <!--<i class="fa fa-people ts"></i>-->
            <img style="width: 35px;" src="/static/index/mingpian.png">
            <p class="text" style="padding-top:9px;">我的名片</p>
          </router-link>
        </div>
        <div class="actived-item" v-if="salesmanInfo.UserBs>0">
          <router-link to="/salesman/myaward" >
            <!--<i class="fa fa-money qd"></i>-->
            <img style="width: 35px;" src="/static/index/jiangjin.png">
            <p class="text" style="padding-top:9px;">我的奖金</p>
          </router-link>
        </div>
        <div class="actived-item">
          <router-link to="/usercenter/fav">
            <!-- <i class="fa fa-aixin fav"></i> -->
            <img style="width: 35px;" src=" ../static/us-xn2.png" alt="">
            <p class="text">我的收藏</p>
          </router-link>
        </div>
        <div class="actived-item">
          <router-link to="/usercenter/shopFav">
            <!-- <i class="fa fa-diamonds fav"></i> -->
            <img style="width: 35px;" src=" ../static/us-xn3.png" alt="">
            <p class="text">店铺收藏</p>
          </router-link>
        </div>
        <div class="actived-item">
          <router-link to="/usercenter/pintuanOrderList">        
            <img style="width: 35px;" src=" ../static/us-xn8.png" alt="">
            <p class="text">拼团订单</p>
          </router-link>
        </div>
        <div class="actived-item">
          <router-link to="/usercenter/ComplaintsSuggestions">
          <!-- <i class="fa fa-services2 ts"></i> -->
          <img style="width: 35px;" src=" ../static/us-xn5.png" alt="">
          <p class="text">投诉建议</p>
          </router-link>
        </div>
      </div>
    </div>

    <XR-bottom ref="XRbottom"></XR-bottom>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import siteconfig from '../../util/siteconfigCache'
import {ErrorCode} from '../../util/errorcode'
export default {
  data() {
    return {
      loginUrl: "",
      showName: "登陆/注册",
      nickName:'',
      loginStatus:0,
	  UserBs:0,
      headPic:'https://frontEnd.xurigo.com/icon/person.jpg',
      salesmanInfo:{
        isRegMember:false,
        MyPurchaseOrderNum:0,
        MyMemberNum:0,
        MyTjMemberNum:0,
        ShopOrderTotal:{
          GetCount:0,
          TotalCount:0,
          TotalMoney:0,
          UnGetCount:0
        },
        MyProxyNum:0,
        UserBsName:'',
      },
      orderCount: {
        SellServiceCount: 0,
        TotalCount: 0,
        WaitDeliveryCount: 0,
        WaitEvalueCount: 0,
        WaitPayCount: 0,
        WaitReceiveCount: 0
      },
      memberFinance :{
        Coin : 0.00,
        Integral: 0,        
        Sun: 0.0000
      },
      bawCount:0.000000,
      salesmanUrl:'/login',
      salesmanUrlText:'升级商品',
      msgCount:0,
      IsBaw: false,
      bg1:'/static/coupon/coupon-uc-1.png',
      bg2:'/static/coupon/coupon-uc-2.png',
      couponWidth: document.documentElement.clientWidth*0.8-20-64,
      myCouponList:[
          // {
          //   name:"商城自营食品类使用",
          //   id:0,
          //   allPrice:300,
          //   discount:60,
          //   type:'平台券', 
          //   value:100,
          //   state:'未领取',
          //   date:'2018.10.10-2019.10.10'
          // },
          // {
          //   name:"商城自营食品类使用",
          //   id:1,
          //   allPrice:300,
          //   discount:60,
          //   type:'店铺券',
          //   value:60,
          //   state:'未领取',
          //   date:'2018.10.10-2019.10.10'
          // },
          // {
          //   name:"商城自营食品类使用",
          //   id:2,
          //   allPrice:300,
          //   discount:60,
          //   type:'平台券', 
          //   value:50,
          //   state:'未领取',
          //   date:'2018.10.10-2019.10.10'
          // },
        ],
        siteConfig:{ MobileBgImage : '' },
        shareTitle:'旭日购商城',
        shareDesc:'',
        shareLinkUrl:'',
        shareImgUrl:'https://imgserver.xurigo.com/upload/images/product/2021/07/26/09441530f0733e-2841-4320-acb7-7266c3a3f5d1.png',
    };
  },
  mounted: function() {
    this.getSiteInfo()
    this.bolang();
    
    if (!this.$store.state.user.SessionId) {
      this.loginUrl = "/Login";
      return;
    }else{
      this.loginUrl = '/usercenter/person';
      this.getIndexInfo()
      this.getMessageCount()	  
      this.getOrderInfo()
      this.getSalesmanInfo()
      this.getFinanceInfo()  
      this.getBawInfo()
	    this.getJftInfo()
      this.getMyCouponList()
    }
    
  },
  methods: {
    getIndexInfo(){      
      const ths = this;
      this.$post("/Salesman/SalesmanServer/GetSalesmanIndexInfo")
      .then(function(res) {
        if (res.IsSuccess) {          
          ths.salesmanInfo = res.Data
          
		  if(res.Data.saleMenCategory){
			var saleMenCategory = new Array();
			for (var i=0;i<res.Data.saleMenCategory.length;i++){
				saleMenCategory[res.Data.saleMenCategory[i].cid] = res.Data.saleMenCategory[i].catename;
				window.localStorage.setItem("saleMenCategory", saleMenCategory);
			}
		  }
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getSiteInfo: function () {
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
            siteconfig.addSiteconfig(res.Data)
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },
    touchStart(e){
      this.startY = e.targetTouches[0].pageY
    },
    copyCode(){
        const input = document.createElement('input');
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('value', this.showName);
        document.body.appendChild(input);
            input.select()
            if (document.execCommand('copy')) {
                document.execCommand('copy');
                this.$refs.XRtoast.success('复制成功',true)  
            }
        document.body.removeChild(input);
    },
    touchMove(e){
      let diff =  e.targetTouches[0].pageY - this.startY
      if(diff<=0){
        diff = 0
      }
      if(diff>=50){
        diff=50
      }
      e.preventDefault();
       this.$el.querySelector('.uc-banner').style.height= 200+diff+'px'
      this.$el.querySelector('.top-main').style.top = 192+diff+'px'
     this.$el.querySelector('#canvas').style.height= 206+diff+'px'
      
      
    },
    touchEnd(){
      var a = this.$el.querySelector('.uc-banner').style.height=200+'px'
      this.$el.querySelector('.top-main').style.top = 192+'px'
      this.$el.querySelector('#canvas').style.height= 206+'px'
      
    },
    getBawInfo: function () {    
      const ths = this;
      this.$post('/Shop/BawServer/GetBawAccountInfo')
        .then(function (res) {
          if(res.IsSuccess){            
            ths.IsBaw = true
            ths.bawCount = res.Data.Coin
          } 
        })
        .catch(function (err) {
          console.log(err)
        })    
    },    
    getSalesmanInfo(){      
      const ths = this;
      this.$post("/Shop/UserServer/GetUserInfo")
      .then(function(res) {
        if (res.IsSuccess) {
          if (!res.Data.IsTestPhone){
            ths.$router.push('/usercenter/mobileBind')
            return;
          }
          ths.initShare(res.Data.user_name);

          
          ths.indexInfo = res.Data
          ths.showName = res.Data.user_name
          ths.loginStatus = 1
		  ths.UserBs = ths.indexInfo.UserBs
          if(res.Data.HeadPic){
            ths.headPic = res.Data.HeadPic
          }
            ths.nickName = res.Data.NickName
			if (ths.nickName == ""){
				ths.nickName = res.Data.user_name
			}
          /*
          if(ths.indexInfo.UserBs>0){
            ths.salesmanUrl = '/salesman/index'
            ths.salesmanUrlText = '我的店铺'
          }else{
            ths.salesmanUrl = '/openSalesmanShop'
          }
          */
          ths.salesmanUrl = '/salesman/salesmanProductIndex'
          ths.salesmanUrlText = '推荐商品'
        }
        // else{
        //   if(res.TypeId == ErrorCode.SessionMissing){
        //     ths.$refs.XRtoast.failed(res.Msg, true)
        //     ths.$router.push('/login')
        //   }
        // }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    initShare(username){
      var ths = this;
      this.$postBase(
        this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
        ).then(function(res) {
        if(!res.IsSuccess){
            //ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.Data.AppId, // 必填，公众号的唯一标识
                timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
                nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
                signature: res.Data.Sign, // 必填，签名，见附录1
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            ths.shareLinkUrl = "https://m.whmulanhui.com/H5Recommend.aspx?source_username=" + username;
            wx.ready(function () {              
                wx.onMenuShareTimeline({
                    title: ths.shareTitle, // 分享标题
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });

                wx.onMenuShareQQ({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });

                wx.onMenuShareAppMessage({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
                wx.onMenuShareQZone({
                    title: ths.shareTitle, // 分享标题
                    desc: ths.shareDesc, // 分享描述
                    link: ths.shareLinkUrl, // 分享链接
                    imgUrl: ths.shareImgUrl, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                    },
                    cancel: function () {
                        // 用户取消分享后执行的回调函数
                    }
                });
            });
        }
      });
    },
    bolang: function() {
      //获得canvas容器
      var canvas = document.getElementById("canvas");
      //获得画笔
      var ctx = canvas.getContext("2d");
      //canvas设置宽度
      canvas.width = canvas.parentNode.offsetWidth;
      //canvas设置高度
      canvas.height = canvas.parentNode.offsetHeight;
      //如果浏览器支持requestAnimFrame则使用requestAnimFrame否则使用setTimeout
      window.requestAnimFrame = (function() {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          function(callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();
      // 波浪大小
      var boHeight = canvas.height / 12;
      var posHeight = canvas.height / 1.2;
      //初始角度为0
      var step = 0;
      //定义三条不同波浪的颜色
      var lines = ["rgba(255,255,255, 0.2)", "rgba(255,255,255, 0.2)"];
      function loop() {
        //清除canvas内容
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        step++;
        //画3个不同颜色的矩形
        for (var j = lines.length - 1; j >= 0; j--) {
          ctx.fillStyle = lines[j];
          //每个矩形的角度都不同，每个之间相差45度
          var angle = (step + j * 50) * Math.PI / 180;
          var deltaHeight = Math.sin(angle) * boHeight;
          var deltaHeightRight = Math.cos(angle) * boHeight;
          ctx.beginPath();
          ctx.moveTo(0, posHeight + deltaHeight);
          ctx.bezierCurveTo(
            canvas.width / 2,
            posHeight + deltaHeight - boHeight,
            canvas.width / 2,
            posHeight + deltaHeightRight - boHeight,
            canvas.width,
            posHeight + deltaHeightRight
          );
          ctx.lineTo(canvas.width, canvas.height);
          ctx.lineTo(0, canvas.height);
          ctx.lineTo(0, posHeight + deltaHeight);
          ctx.closePath();
          ctx.fill();
        }
        requestAnimFrame(loop);
      }
      loop();
    },
    getOrderInfo: function() {
      var ths = this;
      this.$post(
        "/Shop/AllOrderServer/GetOrderTotal"
      ).then(function(res) {
        ths.orderCount = res.Data;
      });
    },    
    getFinanceInfo: function() {
      var ths = this;
      this.$post(
        "/Shop/UserServer/GetMemberFinanceAccount"
      ).then(function(res) {
        ths.memberFinance = res.Data;
      });
    },
	getJftInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/JftServer/GetJftAccountInfo"
      ).then(function(res) {
        if(res.IsSuccess){          
          ths.jftCoin = res.Data.Coin;
		  ths.isActivity = true;
        } else {
		  ths.isActivity = false;
		}
      });
    },    
    getMessageCount(){         
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserMessageTypeCount", this.searchInfo
      ).then(function(res) {
        if(res.IsSuccess){   
          for(var i=0; i< res.Data.length;i++){
            var msgItem = res.Data[i]
            if(msgItem.MessageTypeId != 5){
              if(msgItem.Num>0){
                ths.msgCount += parseInt(msgItem.Num)
              }
            }
          }
        }
      });      
    },
    getMyCouponList: function() {
      var ths = this;
      this.$post(
        "/Shop/CouponServer/WapUserCenterCoupon"
      ).then(function(res) {
        if(res.IsSuccess){
          ths.myCouponList = []
          if(res.Data.StoreCouponItem){
            for(var i = 0; i< res.Data.StoreCouponItem.length;i++){
              ths.myCouponList.push(res.Data.StoreCouponItem[i])
            }
          }
          if(res.Data.PlatformCouponItem){
            for(var i = 0; i< res.Data.PlatformCouponItem.length;i++){
              ths.myCouponList.push(res.Data.PlatformCouponItem[i])
            }
          }
        }
      });
    },    
  }
};
</script>
<style>
.ucindex {
  background: #eee;
  padding-bottom: 56px;
}
.ucindex .uc-banner {
  overflow: hidden;
  /* background: url(/static/us-top-xn.png); */
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
  position: relative;
}
.ucindex .uc-banner .userinfo {
  overflow: hidden;
  position: absolute;
  top: 0px;
  left: 0;
  right: 0;
}
.ucindex .headpic {
  height: 60px;
  width: 60px;
  margin: 60px 15px 10px 20px;
  overflow: hidden;
  border: none;
  float: left;
}
.ucindex .headpic img {
  height: 60px;
  width: 60px;
}
.ucindex .login-btn {
  color: #fff;
  float: left;
  margin: 70px 0 0;
  overflow: hidden;
}
.ucindex .goInfo{
  position: absolute;
  width: 40px;
  height: 40px;
  right: 20px;
  top: 80px;
  color: #fff;
  
  text-align: right;
}
.userinfo .goInfo .fa-angle-right{
  font-size: 16px;
}
.ucindex  .inviteCode{
  margin-top: 5px;
  color: #fff;
  margin-left: 95px;
}
.ucindex  .inviteCode .copyBtn{
  background-color: rgba(200,200,200,0.3);
  color: #fff;
  padding: 3px 5px;
  border-radius: 10px;
}
.ucindex .login-btn .icon {
  display: block;
  color: yellow;
  line-height: 20px;
}
.ucindex .memberLv{
  margin-top: 70px;
  margin-left: 95px;
  color: #fff;
}
.ucindex .memberLv .level{
  background: #000;
  padding: 3px 5px;
  height: 20px;
  line-height: 20px;
  border-radius: 15px;
}
.ucindex .memberLv .level .fa-diamonds{
  color: yellow;
  margin-right: 5px;
}
.ucindex .memberLv .nickName{
  text-overflow: ellipsis;
  float: left;
  overflow: hidden;
  max-width: 30%;
  margin-right: 5px;
  display: block;
  white-space: nowrap;
  color: #fff;
}
.ucindex .link-div {
  overflow: hidden;
  background: black;
  height: 100px;
}
.ucindex .top-nav-list {
  background: url("/static/uclist_bg.png");
  background-size: 100% 100%;
  height: 120px;
  width: 95%;
  overflow: hidden;
  position: absolute;
  top: 145px;
  left: 0;
  margin: 0 auto;
  right: 0;
  padding: 0px 0 10px;
}
.ucindex .top-nav-list .top-nav-item {
  float: left;
  width: 33.33%;
  text-align: center;
}
.ucindex .top-nav-list .top-nav-item i {
  font-size: 14px;
  /* color: #666; */
  color: #fff;
  line-height: 14px;
}
.ucindex .top-nav-list .top-nav-item .text {
  font-size: 12px;
  /* color: #666; */
  color: #fff;
  line-height: 14px;
}
.ucindex .btn-msg {
  position: absolute;
  top: 16px;
  right: 25px;
  font-size: 24px;
  height: 24px;
  line-height: 24px;
  color: #fff;
}
.ucindex .btn-msg .msg-badge {
  top: -5px;
}
.ucindex .uc-banner .userinfo .mu-badge-secondary {
    background-color: #fff;
    color: #ff5252;
}
.ucindex .btn-msg .msg-badge-more {
  top: -5px;
  width: 24px;
  border-radius: 8px;
}
.ucindex .btn-option {
  position: absolute;
  top: 7px;
  right: 55px;
  font-size: 22px;
  color: #fff;
}

.ucindex .index-title {
  padding: 0 20px;
  line-height: 48px;
  border-bottom: 1px solid #f9f9f9;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.ucindex .index-title .text {
  float: left;
  font-size: 14px;
  color: #000;
  font-weight: 700;
  margin: 0 5px;
}
.ucindex .index-title .remark {
  float: right;
  color: #bbb;
  font-size: 12px;
}
.ucindex .index-title .icon {
  float: right;
  font-size: 16px;
  line-height: 46px;
  color: #bbb;
}

.ucindex .top-main {
  position: absolute;
  top: 192px;
  background: white;
  left: 0;
  right: 0;
}
.ucindex .top-main-content {
  overflow: hidden;
  padding: 36px 0 12px;
}
.ucindex .top-main-item {
  float: left;
  text-align: center;
  width: 20%;
}
.ucindex .top-main-item .fa {
  font-size: 22px;
  color: #666;
}
.ucindex .top-main-item .text {
  font-size: 12px;
}

.ucindex .myasset {
  margin-top: 140px;
  margin-bottom: 12px;
  background: white;
}
.ucindex .myasset .asset-list {
  overflow: hidden;
  position: relative;
  background:rgba(255,255,255,0) ;
  height: 66px;
}
.ucindex .myasset .asset-list .zichanBg{
  width: 100%;
  position: absolute;
  bottom: 0;
  z-index: 0;
}
.ucindex .asset-list .asset-item-a {
  overflow: hidden;
  float: left;
  width: 33.33%;
  text-align: center;
  padding: 12px 0;
  position: absolute;
  z-index: 1;
}
.ucindex .asset-list .asset-item-a:nth-child(1){
  left: 0;
}
.ucindex .asset-list .asset-item-a:nth-child(2){
  left: 33.33%;
}
.ucindex .asset-list .asset-item-a:nth-child(3){
  right: 0;
}
.ucindex .asset-list .asset-item-a ~ .asset-item-a {
  /* border-left: 1px solid #fafafa; */
}
.ucindex .asset-list .item {
}
.ucindex .asset-list .item .name {
  font-size: 12px;
  color: #333;
}
.ucindex .asset-list .item .num {
  font-size: 16px;
  color: #ef8569;
}

.ucindex .myactived {
  margin-bottom: 12px;
  background: white;
}
.ucindex .actived-list {
  overflow: hidden;
}
.ucindex .actived-list .actived-item {
  float: left;
  width: 25%;
  text-align: center;
  padding: 12px 0;
}
.ucindex .actived-item .text {
  font-size: 12px;
  color: #333;
  padding-top: 6px;
}
.ucindex .actived-item .fa {
  font-size: 24px;
  color: #333;
}
.ucindex .actived-item .fa.qd {
  width: 24px;
  height: 24px;
  font-size: 16px;
  border-radius: 50%;
  text-align: center;
  line-height: 24px;
  background: #fe8e8e;
  color: white;
}
.ucindex .actived-item .fa.fav {
  color: #ff7096;
}
.ucindex .actived-item .fa.ts {
  color: #bedd4c;
}
.ucindex .coupon .coupon_sec_body{
  margin: 12px 10px;
  overflow: hidden;
  display: inline;
  white-space: nowrap;
  overflow-x: scroll;
  width: 100%;
  float: left;
}
.ucindex .coupon {
  margin-bottom: 12px;
  background: white;
  overflow: hidden;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner{
    background-size: 100% 100%;
    display: inline-block;
  
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner:not(:first-child){
  margin-left: 10px;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponLeft{
  padding: 15px 0;
  background-size:100% 100%; 
  float: left;
  width: 64px;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponLeft .coupon_discount{
  width: 50px;
  height: 50px;
  text-align: center;
  color: #fff;
  border-radius: 50%;
  margin: 0 8px;
  margin-top: 4px;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponLeft.couponGrey .coupon_discount{
  background: #999;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponLeft.couponRink .coupon_discount{
  background: #E95E88;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponLeft.couponYellow .coupon_discount{
  background: orange;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .coupon_discount .cost{
  height: 20px;
  line-height: 30px;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .coupon_discount .money{
  font-size: 22px;
  height: 30px;
  line-height: 25px;
}  
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponRight{
  background-image: url('/static/coupon/coupon-uc-3.png'); 
  background-size:100% 100%; 
  padding: 10px 0;
  float: left;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponRight .coupon_content{
  padding: 0 8px;
  border-left: 1px dotted #999;
  
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .coupon_title{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  height: 23px;
  line-height: 23px;
  color: #fff;
  font-size: 16px;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .coupon_title .coupon_type{
  
  padding: 2px 5px;
  font-size: 12px;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponRight.couponGrey .coupon_content .coupon_title .coupon_type{
  border: 1px solid #999;
  color: #999;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponRight.couponRink .coupon_content .coupon_title .coupon_type{
  border: 1px solid #E95E88;
  color: #E95E88;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponRight.couponYellow .coupon_content .coupon_title .coupon_type{
  border: 1px solid orange;
  color: orange;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .limit{
  font-size: 12px;
  color: #eee;
  margin-top: 5px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ucindex .coupon .coupon_sec_body .coupon_default_inner .couponRight .coupon_content .date{
  font-size: 12px;
  color: #eee;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ucindex .coupon .coupon_btn{
  display: flex;
  width: 100%;
  margin: 20px 0 18px 0;
}
.ucindex .coupon .coupon_btn .mu-flat-button{
  min-width: 33.3%;
  width: 33.3%;
  height: 21px;
  line-height: 21px;
}
.ucindex .coupon .coupon_btn .mu-flat-button:nth-child(2){
  border-left:1px solid #999; 
  border-right:1px solid #999; 
}
.ucindex .coupon .coupon_btn .mu-flat-button .mu-flat-button-label{
  font-size: 14px;
  padding: 0;
  padding-left: 5px;
}
.ucindex .coupon .coupon_btn .mu-flat-button .mu-icon{
  font-size: 16px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/ucindex.vue